module.exports = __webpack_public_path__ + "static/img/jira.1f55871.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jira.png
// module id = 1pbM
// module chunks = 61